document.addEventListener("DOMContentLoaded", function() {

  /* Header Top Bar Countdown */
  if (document.getElementById("strip-announcement-bar")) {
    var announcement_bar = document.querySelector('#strip-announcement-bar');
    var am_message = announcement_bar.dataset.amMessage;
    var pm_message = announcement_bar.dataset.pmMessage;
    var currentDate = new Date()
    var current_hour = currentDate.getHours();
    var strip_bar_message = document.querySelector('#announcement-bar__message');
    if (current_hour < 12){
      strip_bar_message.innerHTML = am_message;
    } else {
      strip_bar_message.innerHTML = pm_message;
    }
    announcement_bar.style.display = 'flex';

    announcement_bar.addEventListener('click', () => {
      var code_to_copy = announcement_bar.dataset.copyCode;
      navigator.clipboard.writeText(code_to_copy).then(() => {
        announcement_bar.classList.add('show-tooltip');
        setTimeout(() => {
          announcement_bar.classList.remove('show-tooltip');
        }, 2000);
        console.log(code_to_copy + ' copied');
      }).catch(err => {
        //console.error('Failed to copy!', err);
      });
    });
  }

/* Product Countdown */
if (document.getElementById("product-countdown")) {
  var product_countdown = document.querySelector('#product-countdown');
  var cutoff = product_countdown.dataset.cutoff.split(":");
  var today = moment();
  var today_date_string = new Date();
  var todays_cutoff = moment(dateToJSONLocal(today_date_string) + ' ' + cutoff[0] + ':' + cutoff[1]);

  // Detect language
  var htmlLang = (document.documentElement.lang || 'en').toLowerCase();
  var isGerman = htmlLang.indexOf('de') === 0;

  function getTomorrowText() {
    return isGerman ? 'morgen' : 'tomorrow';
  }

  function formatDeliveryDate(dateMoment) {
    if (isGerman) {
      var germanWeekdays = ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.'];
      var germanMonths = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];

      var weekday = germanWeekdays[dateMoment.day()];
      var day = dateMoment.date();
      var month = germanMonths[dateMoment.month()];

      return weekday + ' ' + day + '. ' + month;
    } else {
      return dateMoment.format('ddd Do MMMM');
    }
  }

  function getHourUnit() {
    return isGerman ? ' Std ' : 'h ';
  }

  function getMinuteUnit() {
    return isGerman ? ' Min ' : 'm ';
  }

  function getSecondUnit() {
    return isGerman ? ' Sek' : 's ';
  }

  function getDayUnit() {
    return isGerman ? ' Tg ' : 'd ';
  }

  var counting_down_from;
  var days_to_arrive;

  // Delivery Day logic
  if (moment().isoWeekday() == 1) {
    if (today >= todays_cutoff) {
      counting_down_from = 1;
      days_to_arrive = 2;
    } else {
      counting_down_from = 0;
      days_to_arrive = 1;
    }
  } else if (moment().isoWeekday() == 2) {
    if (today >= todays_cutoff) {
      counting_down_from = 1;
      days_to_arrive = 2;
    } else {
      counting_down_from = 0;
      days_to_arrive = 1;
    }
  } else if (moment().isoWeekday() == 3) {
    if (today >= todays_cutoff) {
      counting_down_from = 1;
      days_to_arrive = 2;
    } else {
      counting_down_from = 0;
      days_to_arrive = 1;
    }
  } else if (moment().isoWeekday() == 4) {
    if (today >= todays_cutoff) {
      counting_down_from = 1;
      days_to_arrive = 4;
    } else {
      counting_down_from = 0;
      days_to_arrive = 1;
    }
  } else if (moment().isoWeekday() == 5) {
    if (today >= todays_cutoff) {
      counting_down_from = 3;
      days_to_arrive = 4;
    } else {
      counting_down_from = 0;
      days_to_arrive = 3;
    }
  } else if (moment().isoWeekday() == 6) {
    counting_down_from = 2;
    days_to_arrive = 3;
  } else {
    counting_down_from = 1;
    days_to_arrive = 2;
  }

  var countdown_day_moment = moment();
  if (today >= todays_cutoff) {
    countdown_day_moment.set({ h: 23, m: 59, s: 59 });
  } else {
    countdown_day_moment.set({ h: cutoff[0], m: cutoff[1], s: 0 });
  }

  var extra_days = product_countdown.dataset.extraDays;
  var extra_days_by_product = product_countdown.dataset.extraDaysByProduct;
  var total_days_to_arrive = days_to_arrive + parseInt(extra_days) + parseInt(extra_days_by_product);

  var product_countdown_date = document.querySelector('#product-countdown__date');

  if (total_days_to_arrive == 1) {
    product_countdown_date.innerHTML = getTomorrowText();
  } else {
    var delivery_day_moment = moment().add(total_days_to_arrive, 'days');

    // Avoid weekends
    if (delivery_day_moment.isoWeekday() === 6) {
      total_days_to_arrive += 2;
    } else if (delivery_day_moment.isoWeekday() === 7) {
      total_days_to_arrive += 1;
    }

    delivery_day_moment = moment().add(total_days_to_arrive, 'days');
    delivery_day_moment.set({ h: cutoff[0], m: cutoff[1], s: 0 });

    product_countdown_date.innerHTML = formatDeliveryDate(delivery_day_moment);
  }

  // Countdown timer
  var timer = setInterval(function () {
    if (moment().isAfter(countdown_day_moment)) {
      clearInterval(timer);
      product_countdown.style.display = 'none';
    } else {
      product_countdown.style.display = 'flex';

      var var_live_days_countdown = '';
      if (countdown(countdown_day_moment).days != 0) {
        var var_live_days_countdown = countdown(countdown_day_moment).days + getDayUnit();
      }

      var hours = countdown(countdown_day_moment).hours;
      var minutes = countdown(countdown_day_moment).minutes;
      // var seconds = countdown(countdown_day_moment).seconds;

      var hours_string = hours < 10 ? '0' + hours : hours;
      hours_string = hours_string == '00' ? '' : hours_string + getHourUnit();

      var minutes_string = minutes < 10 ? '0' + minutes : minutes;
      // var seconds_string = seconds < 10 ? '0' + seconds : seconds;

      var live_time = var_live_days_countdown + minutes_string;
      if (hours_string !== '') {
        live_time = var_live_days_countdown + hours_string + minutes_string;
      }

      //live_time = live_time + getMinuteUnit() + seconds_string + getSecondUnit();
      live_time = live_time + getMinuteUnit();

      document.querySelector('#product-countdown__timer').innerHTML = live_time;
    }
  }, 1000);
}

  /* Product Scarcity Bar */
  // var product_scarcity_value = document.querySelector('#product-scarcity__value');
  // var product_scarcity_progress = document.querySelector('#product-scarcity__progress');
  // updateProductScarcityLevels(product_scarcity_value, product_scarcity_progress);

  // var stored_selected_variants = {};
  // var selected_variant = getSelectedProductVariant();
  // if (product_scarcity_value) {
  //   stored_selected_variants[selected_variant] = product_scarcity_value.innerHTML;
  // }
  
  // const product_forms = document.querySelectorAll("form.shopify-product-form");
  // for (let i = 0; i < product_forms.length; i++) {
  //   product_forms[i].addEventListener("change", function() {
  //     setTimeout(
  //       function() {
  //         var selected_variant = getSelectedProductVariant();
  //         updateCustomAddToCartButtons(selected_variant);
  //         if (!(selected_variant in stored_selected_variants)) {
  //           updateProductScarcityLevels(product_scarcity_value, product_scarcity_progress);
  //           var selected_variant = getSelectedProductVariant();
  //           if (product_scarcity_value) {
  //             stored_selected_variants[selected_variant] = product_scarcity_value.innerHTML;
  //           }
  //         } else {
  //           updateProductScarcityLevels(product_scarcity_value, product_scarcity_progress, stored_selected_variants[selected_variant]);
  //         }
  //     }, 500);
  //   });
  // }

  // function updateProductScarcityLevels(product_scarcity_value, product_scarcity_progress, previously_set_level) {
  //   if (previously_set_level === undefined) {
  //     var scarcity_stock_level = randomNumber(3, 8);
  //   } else {
  //     var scarcity_stock_level = previously_set_level;
  //   }
  //   if (product_scarcity_value) {
  //     product_scarcity_value.innerHTML = scarcity_stock_level;
  //   }
  //   var scarcity_percentage = (scarcity_stock_level / 8) * 100;
  //   if (product_scarcity_progress) {
  //     product_scarcity_progress.style.width = scarcity_percentage + "%";
  //   }
  // }

  /* Product Scarcity Bar NEW */
  function randomNumber(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  var product_scarcity_container = document.querySelector(".product-scarcity");
  var product_scarcity_value = document.querySelector("#product-scarcity__value");
  var product_scarcity_progress = document.querySelector("#product-scarcity__progress");

  var stored_selected_variants = {};
  var updateInterval = null; // Store interval reference

  // Hide scarcity div by default (using display: none)
  if (product_scarcity_container) {
    product_scarcity_container.style.display = "none";
  }

  function getSelectedProductVariant() {
    var selectedVariantInput = document.querySelector('input[name="id"]:checked') || document.querySelector('input[name="id"]');
    return selectedVariantInput ? selectedVariantInput.value : null;
  }

  function updateProductScarcityLevels(scarcity_stock_level) {
    product_scarcity_value = document.querySelector("#product-scarcity__value"); // Re-select in case Shopify replaces it
    product_scarcity_progress = document.querySelector("#product-scarcity__progress");
    product_scarcity_container = document.querySelector(".product-scarcity"); // Re-select container

    if (product_scarcity_value) {
      product_scarcity_value.innerHTML = scarcity_stock_level;
    }

    var scarcity_percentage = (scarcity_stock_level / 8) * 100;
    if (product_scarcity_progress) {
      product_scarcity_progress.style.width = scarcity_percentage + "%";
    }

    // Show the scarcity div when a valid stock level is set
    if (product_scarcity_container) {
      product_scarcity_container.style.display = scarcity_stock_level > 0 ? "flex" : "none";
    }
  }

  function handleVariantChange() {
    setTimeout(function () {
      var selected_variant = getSelectedProductVariant();
      if (!selected_variant) return;

      console.log(selected_variant);

      updateCustomAddToCartButtons(selected_variant);

      // Immediately hide the scarcity div on variant change
      if (product_scarcity_container) {
        product_scarcity_container.style.display = "none";
      }

      if (!(selected_variant in stored_selected_variants)) {
        stored_selected_variants[selected_variant] = randomNumber(3, 8);
      }

      // Ensure the scarcity value is set before showing the div
      var scarcity_stock_level = stored_selected_variants[selected_variant];

      updateProductScarcityLevels(scarcity_stock_level);
      updateKlarnaMessaging();

      // Clear and restart setInterval to prevent performance issues
      if (updateInterval) clearInterval(updateInterval);
      updateInterval = setInterval(() => {
        updateProductScarcityLevels(scarcity_stock_level);
      }, 500);
    }, 500);
  }

  // Initial update
  setTimeout(() => {
    var selected_variant = getSelectedProductVariant();
    if (selected_variant && !(selected_variant in stored_selected_variants)) {
      stored_selected_variants[selected_variant] = randomNumber(3, 8);
    }
    if (selected_variant) {
      updateProductScarcityLevels(stored_selected_variants[selected_variant]);
    }
  }, 1000);

  // Attach event listener to product forms
  const product_forms = document.querySelectorAll("form.shopify-product-form");
  product_forms.forEach((form) => form.addEventListener("change", handleVariantChange));


  

  let accordions = document.querySelectorAll(".product-info .product-info__block-item details.product-info__accordion");
  if (accordions.length > 0) {
      accordions.forEach((accordion) => {
          accordion.removeAttribute("open");
      });
      accordions[0].setAttribute("open", "true");
  }

  // Product Gallery Zoom
  if (window.innerWidth <= 768) {
    const observer = new MutationObserver(() => {
      const target = document.querySelector('.pswp.pswp--open.pswp--zoom-allowed');
      const elementClass = 'pswp__product-gallery-zoom-text';
      if (target && !target.querySelector('.' + elementClass)) {
        insertProductGalleryZoomText(target, elementClass);
      }
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    document.addEventListener('click', function (e) {
      const closeBtn = e.target.closest('.pswp__button--close');
      if (closeBtn) {
        const customEl = document.querySelector('.pswp__product-gallery-zoom-text');
        if (!customEl) return;
        customEl.classList.add('hidden');
        setTimeout(() => {
          customEl.remove();
        }, 300);
      }
    });
  }


  

  // // Header Search
  // var search_bar_buttons = document.querySelectorAll('.js-toggle-header-search');
  // var search_bar = document.querySelector('.js-search-bar-wrapper');
  // for (let i = 0; i < search_bar_buttons.length; i++) {
  //   search_bar_buttons[i].onclick = function(){
  //     search_bar.classList.toggle('active');
  //   }
  // }

  
  // var search_bar_button = document.querySelector('.js-search-bar-button');
  // var search_bar = document.querySelector('.js-search-bar-wrapper');
  // search_bar_button.onclick = function(){
  //   console.log('toggle search');
  //   if (window.getComputedStyle(search_bar).display === 'block' || window.getComputedStyle(search_bar).display === 'inline') {
  //     search_bar.style.display = 'none';
  //   } else {
  //     if (window.innerWidth < 992) {
  //       search_bar.style.display = 'block';
  //     } else {
  //       search_bar.style.display = 'inline';
  //     }
  //   }
  // }

  // // Read more questions
  // const product_questions_read_more = document.querySelectorAll(".product-bottom__questions__read-more");
  // for (let i = 0; i < product_questions_read_more.length; i++) {
  //   product_questions_read_more[i].onclick = function(){
  //     product_questions_read_more[i].parentNode.style.maxHeight = 'none';
  //     product_questions_read_more[i].parentNode.removeChild(product_questions_read_more[i]);
  //   }
  // }

  // // Size guide button
  // var size_guide_button = document.querySelector('#js-size-guide-button');
  // var size_guide_modal = document.querySelector('.product-variant-size-guide-modal');
  // if (size_guide_button) {
  //   size_guide_button.onclick = function(){
  //     size_guide_modal.style.display = 'flex';
  //   }
  // }
  // var close_size_guide = document.querySelector('.product-variant-size-guide-modal__close');
  // if (size_guide_modal) {
  //   size_guide_modal.onclick = function(){
  //     size_guide_modal.style.display = 'none';
  //   }
  // }

  // Product Testimonial Fallback
  // setTimeout(() => {
  //   const widget = document.querySelector('loox-snippets-widget');
  //   const testimonialElement = document.querySelector('.product-page-testimonial');
  //   if (widget && widget.shadowRoot && widget.shadowRoot.querySelector('div.container')) {
  //       // Loox review widget exists as product has reviews, no need to display fallback
  //   } else {
  //       testimonialElement.style.display = 'flex';
  //   }
  // }, 500);

  // About us custom video play icons
  document.querySelectorAll('.section--about-us-content__video-icon').forEach(icon => {
    icon.addEventListener('click', () => {
      const video = icon.previousElementSibling;
      if (video && video.tagName.toLowerCase() === 'video') {
        video.setAttribute('autoplay', '');
        video.setAttribute('controls', '');
        video.play();

        icon.style.display = 'none';
      }
    });
  });

  
});

window.addEventListener('load', function(event) {
  // Swipers
  var swiper = new Swiper('.swiper--sticky-bar', {
    loop: true,
    speed: 600,
    // autoplay: true,
    slidesPerView: 1,
    navigation: {
      nextEl: '.swiper-button-next--sticky-bar',
      prevEl: '.swiper-button-prev--sticky-bar',
    },
    breakpoints: {
      900: {
        slidesPerView: 4,
        autoplay: false
      }
    }
  });

  var about_us_swiper = new Swiper('.swiper--about-us-artists', {
    slidesPerView: 2,
    spaceBetween: 20,
    freeMode: true,
    mousewheel: {
      forceToAxis: true, 
      releaseOnEdges: true, 
    },
    simulateTouch: true,
    touchStartPreventDefault: false, 
    navigation: {
      nextEl: '.swiper-button-next--about-us-artists',
      prevEl: '.swiper-button-prev--about-us-artists',
    },
    breakpoints: {
      900: {
        slidesPerView: 3,
      }
    }
  });
});

function dateToJSONLocal(date) {
  var local = new Date(date);
  local.setMinutes(date.getMinutes() - date.getTimezoneOffset());
  return local.toJSON().slice(0, 10);
}

function randomNumber(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min);
};

function getSelectedProductVariant() {
  var productForm = document.querySelector("form.shopify-product-form");
  const variantInputId = productForm.querySelector('input[name="id"]');
  if (variantInputId) {
    return variantInputId.value;
  }
  return false;
}

function updateProductScarcityLevels(product_scarcity_value, product_scarcity_progress, previously_set_level) {
  if (previously_set_level === undefined) {
    var scarcity_stock_level = randomNumber(3, 8);
  } else {
    var scarcity_stock_level = previously_set_level;
  }
  if (product_scarcity_value) {
    product_scarcity_value.innerHTML = scarcity_stock_level;
  }
  var scarcity_percentage = (scarcity_stock_level / 8) * 100;
  if (product_scarcity_progress) {
    product_scarcity_progress.style.width = scarcity_percentage + "%";
  }
}

function updateKlarnaMessaging() {
  const newPriceElement = document.querySelector('sale-price.text-on-sale');
  const priceText = newPriceElement.innerText;
  const cleanedPrice = priceText.replace(/[^\d.-]/g, '');
  const numericPrice = parseFloat(cleanedPrice);
  const dividedPrice = numericPrice / 3;
  const roundedPrice = dividedPrice.toFixed(2);
  const klarnaPriceElement = document.querySelector('#product-info__klarna-price');
  klarnaPriceElement.innerText = '£' + roundedPrice;
}

function updateCustomAddToCartButtons(variant_id) {
  const custom_add_to_cart_buttons = document.querySelectorAll(".custom_add_to_cart_button_id_field");
  for (let i = 0; i < custom_add_to_cart_buttons.length; i++) {
    custom_add_to_cart_buttons[i].value = variant_id;
  }
}

// Cart Drawer Countdown
let lastVisibleState = null;
let debounceTimer;
let countdownTimer;
let countdownValue = 10 * 60; // 10 minutes in seconds (10:00)

// Function to check if the cart drawer is visible
function isCartDrawerVisible() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return false;

    const style = window.getComputedStyle(cartDrawer);
    return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
}

// Function to check if popup was shown within 24 hours
function shouldShowKlaviyoPopup() {
    const lastShown = localStorage.getItem('klaviyoPopupLastShown');
    if (!lastShown) return true;

    const now = Date.now();
    const elapsed = now - parseInt(lastShown, 10);
    const hours24 = 24 * 60 * 60 * 1000;

    return elapsed > hours24;
}

// Function to store the time popup was last shown
function setKlaviyoPopupShownTimestamp() {
    localStorage.setItem('klaviyoPopupLastShown', Date.now().toString());
}

// Debounced function to check the visibility
function checkVisibility() {
    clearTimeout(debounceTimer); // Clear any previous timer

    debounceTimer = setTimeout(() => {
        const isVisible = isCartDrawerVisible();
        if (isVisible !== lastVisibleState) {
            lastVisibleState = isVisible;

            if (isVisible) {
                console.log('Cart drawer is now visible!');
                startCountdown();
            } else {
                console.log('Cart drawer is now hidden!');
                stopCountdown();
                if (shouldShowKlaviyoPopup()) {
                    showKlaviyoPopup();
                    setKlaviyoPopupShownTimestamp();
                }
            }
        }
    }, 300); // Adjust the debounce delay (in milliseconds) based on your needs
}

// Start the countdown
function startCountdown() {
    // If the countdown is already running, do nothing
    if (countdownTimer) return;

    const timerElement = document.querySelector('.cart-drawer__timer');
    const countdownContainer = document.querySelector('.cart-drawer__countdown');

    countdownContainer.style.display = 'block';
    
    if (timerElement && countdownContainer) {
        countdownTimer = setInterval(() => {
            const minutes = Math.floor(countdownValue / 60);
            const seconds = countdownValue % 60;
            timerElement.textContent = `${formatTime(minutes)}:${formatTime(seconds)}`;
            countdownValue--;

            if (countdownValue < 0) {
                stopCountdown();
                countdownContainer.style.display = 'none'; // Hide the countdown container when time reaches zero
                console.log('Countdown finished, cart drawer countdown hidden');
            }
        }, 1000); // Update every second
    }
}

// Stop the countdown
function stopCountdown() {
    clearInterval(countdownTimer);
    countdownTimer = null;
}

// Format the time to always show two digits
function formatTime(time) {
    return time < 10 ? `0${time}` : time;
}

// Set up the MutationObserver to watch for attribute changes
const cartDrawerObserver = new MutationObserver(checkVisibility);

// Observe changes to the cart-drawer
document.addEventListener('DOMContentLoaded', () => {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
        cartDrawerObserver.observe(cartDrawer, {
            attributes: true,
            childList: false,
            subtree: false
        });
    }
});

function showKlaviyoPopup() {
  console.log('Show Klaviyo popup as Cart drawer is now hidden!');
  window._klOnsite = window._klOnsite || [];
  window._klOnsite.push(['openForm', 'XCw4wF']);
}
// End Cart Drawer Countdown

//added 'add-to-cart' class for theme-scientist compatibility
document.querySelectorAll('button.add-to-cart div').forEach(el => {
  el.classList.add('add-to-cart');
});


// document.querySelectorAll('.product-sticky-cart__options-wrapper select').forEach(selectElement => {
//   selectElement.addEventListener('change', function() {
//    const currentImage = document.querySelector('.product-sticky-cart__row .js-product-sticky-cart-image');
// if (currentImage) {
//     currentImage.style.display = 'none';
// }
//     setTimeout(() => {
//     const currentImageSrc = document.querySelector('.product-images__slider .slick-slide.slick-current.slick-active img').getAttribute('src');
//     const currentImage = document.querySelector('.product-sticky-cart__row .js-product-sticky-cart-image');
// if (currentImage) {
//     currentImage.style.display = 'block';
// }
//     document.querySelector('.product-sticky-cart__row .js-product-sticky-cart-image').setAttribute('src', currentImageSrc);
//     document.querySelector('.product-sticky-cart__row .js-product-sticky-cart-image').setAttribute('srcset', currentImageSrc);
//     }, 500);
//   });
// });

function insertProductGalleryZoomText(target, elementClass) {
  const customDiv = document.createElement('div');
  customDiv.className = elementClass + ' hidden';
  customDiv.innerHTML = `
    <div>
      <img src="https://cdn.shopify.com/s/files/1/0127/4848/8794/files/Pinch_Zoom_In-1024_2.jpg?v=1747424553" alt="Pinch to zoom icon" />
      <p>Pinch To Zoom</p>
    </div>
  `;
  target.appendChild(customDiv);

  setTimeout(() => {
    customDiv.classList.remove('hidden');
  }, 300);
}
